export default __webpack_public_path__ + "static/media/group-598@2x.283ec368.png";